module.exports = __webpack_public_path__ + "img/inu_gallery14.735ac522.jpg";